(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-swatches"] && !Shopify.designMode) return;
  try {
    (function() {
    function initCardSwatches() {
      document.querySelectorAll('.card-swatches').forEach(function(swatchContainer) {
        const card = swatchContainer.closest('.card-wrapper');
        if (!card) return;

        const primaryImage = card.querySelector('.card__media img:first-child');
        const originalSrc = primaryImage ? primaryImage.src : null;
        const originalSrcset = primaryImage ? primaryImage.srcset : null;

        swatchContainer.querySelectorAll('.card-swatch[data-preview-image]').forEach(function(swatch) {
          swatch.addEventListener('mouseenter', function() {
            const previewUrl = this.dataset.previewImage;
            if (primaryImage && previewUrl) {
              primaryImage.src = previewUrl;
              primaryImage.srcset = '';
            }
          });

          swatch.addEventListener('mouseleave', function() {
            if (primaryImage && originalSrc) {
              primaryImage.src = originalSrc;
              primaryImage.srcset = originalSrcset || '';
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCardSwatches);
    } else {
      initCardSwatches();
    }

    document.addEventListener('shopify:section:load', initCardSwatches);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-swatch"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (event.target.classList.contains('swatch__input')) {
      const fieldset = event.target.closest('fieldset');
      if (fieldset) {
        const selectedValueSpan = fieldset.querySelector('.swatch-selected-value');
        if (selectedValueSpan) {
          selectedValueSpan.textContent = event.target.value;
        }
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
